export default __webpack_public_path__ + "torre-ghost.9bff0a1.svg";